import { Button, CircularProgress, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import React, { useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { fetchRoadSpecialEventAudioStart } from 'redux/actions/audioPreview.action';
import { fetchRoadConditionsStart, saveRoadConditionsStart } from 'redux/actions/roadCondition.action';
import DiscardAlert from './DiscardAlert';
import EditorModal from './EditorsModal';
import styles from './RoadCondition.module.scss';
import { locations } from './roadConditionConstants';
import SubmitAlertModal from './SubmitAlertModal';



const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    button: {
        margin: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {
            minWidth: 12,
            paddingLeft: '1 !important',
            paddingRight: '1 !important',
            "& .MuiButton-startIcon": {
                margin: 0
            }
        }
    },
}));

const RoadCondition = props => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { register, control, handleSubmit, getValues, reset, setValue, formState } = useForm();
    const roadConditionState = useSelector((state) => state.roadConditions);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isNotShowPlayButton, setNotShowPlayButton] = useState({});
    const roadSpecialEventsAudioState = useSelector((state) => state.audioPreview);
    const [showSubmitAlertModal, setShowSubmitAlertModal] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    const [dirtyFieldsList, setDirtyFieldsList] = useState([]);
    const [audioIndex, setAudioIndex] = useState(-1);
    const [showModal, setShowModal] = useState(false);
    const [nextTabIndex, setNextTabIndex] = useState(props.nextTabIndex);
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const { fields } = useFieldArray(
        {
            control,
            name: "roadConditions"
        }
    );
    const onSubmit = (data) => {
        const finalData = [];
        if (data.roadConditions) {
            data.roadConditions.map(roadCond => {
                if (roadCond.message !== undefined && roadCond.message?.trim() !== "" && roadCond.message !== null) {
                    finalData.push(roadCond);
                }
            })
            dispatch(saveRoadConditionsStart({ "roadConditions": finalData }));
            setIsSubmitted(true);
        }
    }
    const fetchAudio = (textMessage, index) => {
        textMessage = getValues().roadConditions[index].message;
        if (textMessage && textMessage.trim() !== '') {
            setAudioIndex(index);
            const indexObj = {};
            indexObj[index] = true;
            setNotShowPlayButton(indexObj);
            dispatch(fetchRoadSpecialEventAudioStart(textMessage));
        }
    }
    const showPlayButton = (index) => {
        const textMessage = getValues();
        if (textMessage && textMessage.roadConditions && textMessage.roadConditions[index].message && textMessage.roadConditions[index].message.trim() !== '') {
            return true;
        }
        else {
            return false;
        }
    }
    const handleMessageChange = (event, index, location) => {
        const indexObj = {};
        indexObj[index] = false;
        setNotShowPlayButton(indexObj);
        const dFields = dirtyFieldsList;
        if (dFields.indexOf(locations[location]) === -1) {
            dFields.push(locations[location]);
        }
        setDirtyFieldsList(dFields);
        setIsDirty(true);
        return event;
    }
    const showSubmitAlert = (data) => {
        setNotShowPlayButton({})
        if (!(roadConditionState.roadConditions && roadConditionState.roadConditions.roadConditions)) {
            return;
        }
        setShowSubmitAlertModal(true);
    };
    const onDiscard = () => {
        props.handleChange(nextTabIndex);
        reset({ "roadConditions": roadConditionState.roadConditions.roadConditions });
        setShowModal(false);
    }
    const onSave = () => {
        props.handleChange(nextTabIndex);
        setShowModal(false)
    }
    const onHide = () => {
        props.handleChange(0);
        setShowModal(false)
    }
    const onDiscardYes = () => {
        setShowDiscardModal(false);
        setNotShowPlayButton({})
        setValue("roadConditions", roadConditionState.roadConditions.roadConditions);
        setIsDirty(false);
        setDirtyFieldsList([]);
    }
    const onDiscardNo = () => {
        setShowDiscardModal(false); setNotShowPlayButton({})
    }
    const onDiscardHide = () => {
        setShowDiscardModal(false); setNotShowPlayButton({})
    }
    const onsubmitAlertHide = () => {
        setShowSubmitAlertModal(false);
    }
    useEffect(() => { dispatch(fetchRoadConditionsStart()) }, []);
    useEffect(() => {
        if (roadConditionState.roadConditions && roadConditionState.roadConditions.roadConditions) {

            reset({ "roadConditions": roadConditionState.roadConditions.roadConditions });
            setDirtyFieldsList([]);
        }
    }, [roadConditionState.roadConditions,reset]);
    useEffect(() => {
        if (roadConditionState && roadConditionState.isSaved && isSubmitted) {
            props.successToast("Successfully Saved Road Conditions");
            setIsSubmitted(false);
            reset({});
            setDirtyFieldsList([]);
            setIsDirty(false);
            setShowSubmitAlertModal(false);
            dispatch(fetchRoadConditionsStart());
            onSave();
        }
        else if (roadConditionState && roadConditionState.error && nextTabIndex === 0) {
            props.errorToast(roadConditionState.error);
            setIsSubmitted(false);
            onSave();
        }
        else if (roadSpecialEventsAudioState && roadSpecialEventsAudioState.error && nextTabIndex === 0) {
            props.errorToast(roadSpecialEventsAudioState.error);
        }
    }, [roadConditionState.isSaved, roadConditionState.error, roadSpecialEventsAudioState.error]);
    useEffect(() => {
        if (!isDirty) {
            props.handleChange(nextTabIndex);
        }
    }, [formState, props.nextTabIndex])

    useEffect(() => {
        if (!(roadConditionState.roadConditions && roadConditionState.roadConditions.roadConditions)) {
            return;
        }; setNotShowPlayButton({})
        setShowModal(true); setNextTabIndex(props.nextTabIndex);
    }, [props.nextTabIndex]);
    return (
        <>
            <form onSubmit={handleSubmit(showSubmitAlert)}>
                {props.nextTabIndex !== 0 && showModal && isDirty &&
                    <EditorModal
                        onSave={handleSubmit(onSubmit)}
                        onDiscard={onDiscard}
                        onHide={onHide}
                        show={showModal}
                        modalBody={dirtyFieldsList}
                        modalTitle="You have made changes to the following road condition locations. Would you like to submit these changes or discard them?" />
                }
                {props.nextTabIndex === 0 && showSubmitAlertModal && isDirty &&
                    <SubmitAlertModal
                        onSave={handleSubmit(onSubmit)}
                        onDiscard={onsubmitAlertHide}
                        onHide={onsubmitAlertHide}
                        show={showSubmitAlertModal}
                        modalBody={dirtyFieldsList}
                        modalTitle="Location Updates"
                        modalMessage="You have made changes to the following road condition locations. Would you like to submit these changes?"
                    />
                }
                {showDiscardModal &&
                    <DiscardAlert
                        onYes={onDiscardYes}
                        onCancel={onDiscardNo}
                        onHide={onDiscardHide}
                        show={showDiscardModal}
                        modalBody={"Discard All Changes ? "} />
                }
                {roadConditionState.loading ?
                    <div className={" row " + styles.minh40 + " " + styles.loader}><CircularProgress fontSize="large" /></div> : <>
                        <div className={styles.topSubmitRow + " row"}>
                            <div className={"col col-md-12 col-xs-12 " + styles.rightAlign}>
                                <Button title="Submit Changes" disabled={!isDirty} className={isDirty ? styles.submitButton : styles.disableButton} variant="contained" color="primary" type="Submit">Submit</Button>
                                <span style={{ padding: '5px' }}></span>
                                <Button disabled={!isDirty} className={isDirty ? styles.cancelButton : styles.disableButton} variant="outlined" color="secondary" onClick={() => setShowDiscardModal(true)}>Cancel</Button>
                            </div>
                        </div>
                        <div className={styles.rowEnd}></div>
                        <div className={"row"} style={{ marginLeft: "10px", marginRight: "10px" }}>
                            <div className="col col-md-12 col-xs-12">
                                <div className={styles.topGap} ><h2>Road Condition Location Options</h2></div>
                                <div>
                                    <span>Last Updated Date: </span>
                                    <span>{fields[0] && fields[0].lastModifiedDateTime ? fields[0].lastModifiedDateTime.replace('T', ' ').substring(0, 16) : ''}</span>
                                </div>
                            </div>
                        </div>
                        {
                            fields.map((roadCondition, index) => (
                                <div key={index}>
                                    <div className={" row " + styles.rowMargin}>
                                        <div className={styles.mt50 + "  col-md-12 col-xs-12"}>
                                            <Controller
                                                as={<InputBase
                                                    readOnly
                                                    hidden
                                                    className={styles.noBorder + " " + styles.fs14}
                                                    rows={2}
                                                    value={roadCondition.location}
                                                    name={`roadConditions[index].location`}
                                                    ref={register}
                                                    multiline
                                                />}
                                                name={`roadConditions[${index}].location`}
                                                control={control}
                                                defaultValue={roadCondition.location}
                                            />
                                            <strong>{locations[roadCondition.location]}</strong>
                                        </div>
                                        <div className={" col-md-12 col-xs-12"}>
                                            <div className={styles.colorBorder}>
                                                <Toolbar className={styles.border} style={{ background: "#f0f3f4", minHeight: "63px", padding: "0" }} disableGutters={false}>
                                                    <div className={"row " + styles.w100}>
                                                        {(roadCondition.message || showPlayButton(index)) && <div className={"col col-xs-12 col-md-12 " + styles.rightAlign}>
                                                            {!isNotShowPlayButton[index] ? <Button title="Preview Audio" onClick={() => fetchAudio(roadCondition.message, index)} > <PlayCircleFilledIcon style={{ color: "#c60c30", fontSize: "30px" }} /></Button> :
                                                                (index === audioIndex && roadSpecialEventsAudioState.loading ? <CircularProgress /> :
                                                                    <audio controls autoPlay style={{ top: "3px", position: "relative", width: "100%" }}>
                                                                        <source src={index === audioIndex ? roadSpecialEventsAudioState.audioResponse : "ok"} type="audio/wav" ></source>
                                                                    </audio>)}
                                                        </div>}
                                                    </div>
                                                </Toolbar>
                                                <Controller
                                                    render={(props) => (
                                                        <TextField
                                                            {...props}
                                                            id="outlined-secondary"
                                                            variant="outlined"
                                                            InputProps={{
                                                                classes: {
                                                                    input: styles.fs14,
                                                                },
                                                            }}
                                                            multiline
                                                            fullWidth
                                                            rows={5}
                                                            color="primary"
                                                            ref={register}
                                                            onChange={(value) => {
                                                                props.onChange(value);
                                                                handleMessageChange(value, index, roadCondition.location);
                                                            }}
                                                            value={props.value}
                                                        />
                                                    )}
                                                    name={`roadConditions[${index}].message`}
                                                    control={control}
                                                    defaultValue={roadCondition.message ? roadCondition.message : ''}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </>}
                <div className={styles.topSubmitRow + " row"}>
                    <div className="col col-md-5 col-xs-5"></div>
                    <div className={"col col-md-7 col-xs-7 " + styles.rightAlign}>
                        <Button title="Submit Changes" disabled={!isDirty} className={isDirty ? styles.submitButton : styles.disableButton} variant="contained" color="primary" type="Submit">Submit</Button>
                        <span style={{ padding: '5px' }}></span>
                        <Button disabled={!isDirty} className={isDirty ? styles.cancelButton : styles.disableButton} variant="outlined" color="secondary" onClick={() => setShowDiscardModal(true)}>Cancel</Button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default RoadCondition;